import review from '../../../../icons/review.svg';
import shieldProtected3 from '../../../../icons/shieldProtected3.svg';
import receiveCall from '../../../../icons/receiveCall.svg';
import reviewApproval from '../../../../icons/reviewApproval.svg';
import onlineApplication from '../../../../icons/onlineApplication.svg';
import printPolicy from '../../../../icons/printPolicy.svg';
import protectWhatYouLove from '../../../../icons/protectWhatYouLove.svg';
import carrierChoice from '../../../../icons/carrierChoice.svg';
import competitiveRates from '../../../../icons/competitiveRates.svg';
import easyQuoting from '../../../../icons/easyQuoting.svg';
import submitApplication from '../../../../icons/submitApplication.svg';

export const ChoiceConvenienceData = [
    {
        text: "From lifetime protection and cash accumulation to coverage for final expenses, we make it easy to secure your family's financial future.",
        icon: protectWhatYouLove,
    },
    {
        text: "Choice of top-rated carriers",
        icon: carrierChoice,
    },
    {
        text: "Most competitive rates",
        icon: competitiveRates,
    },
    {
        text: "Easy quoting process and online application",
        icon: easyQuoting,
    },
];

export const EasyStepsScheduleData = [
    {
        text: "Schedule a quick call with one of our knowledgeable, licensed insurance experts",
        icon: onlineApplication,
    },
    {
        text: "Compare customized options from top rated carriers",
        icon: reviewApproval,
    },
    {
        text: "Choose a solution that meets your needs and start the easy online application",
        icon: printPolicy,
    },
];

export const EasyStepsConfirmationData = [
    {
        text: "Expect a call from “Covr” with a 208 area code",
        icon: receiveCall,
    },
    {
        text: "Speak with your licensed expert to review your best options, including:",
        subText: [
            "Lifetime coverage",
            "Cash value accumulation",
            "Final expense protection",
        ],
        icon: review,
    },
    {
        text: "Choose your solution and let us handle the application",
        subText: ["No payment is due until you review and approve your policy"],
        icon: submitApplication,
    },
    {
        text: "Once approved, sign and pay initial premium to activate your coverage",
        icon: shieldProtected3,
    },
];

export const ComplimentaryReview = {
    title: "Schedule your complimentary review",
    text: "In order to customize your personal solution, we need to connect for a quick call. Your designated insurance expert will review your best options from a choice of the top-rated insurance companies that offer the most competitive rates. The quoting and application process is easy, completely confidential and takes less than 15 minutes.",
    subText: "Schedule a call within a convenient 30-minute time window or have one of our life insurance professionals reach out to you within one business day.",
    note: "Your information is private and secure, and is never sold to a third party.",
    appointmentTimeTitle: "Available Appointment Time Frames",
};

export const ChoiceConvenienceBusinessSolutionsData = [
    {
        text: "From buy/sell and key person to coverage for small business loans, we make it easy to secure your business’s financial future.",
        icon: protectWhatYouLove,
    },
    {
        text: "Choice of top-rated carriers",
        icon: carrierChoice,
    },
    {
        text: "Most competitive rates",
        icon: competitiveRates,
    },
    {
        text: "Easy quoting process and online application",
        icon: easyQuoting,
    },
];

export const EasyStepsScheduleBusinessSolutionsData = [
    {
        text: "Schedule a quick call with one of our knowledgeable, licensed insurance specialists",
        icon: onlineApplication,
    },
    {
        text: "Compare customized options from top rated carriers",
        icon: reviewApproval,
    },
    {
        text: "Choose a solution that meets your needs and start the easy online application",
        icon: printPolicy,
    },
];

export const EasyStepsConfirmationBusinessSolutionsData = [
    {
        text: "Expect a call from “Covr” with a 208 area code",
        icon: receiveCall,
    },
    {
        text: "Speak with your licensed specialist to review your best options, including:",
        subText: [
            "Buy/Sell Coverage",
            "Key Person Coverage",
            "Small Business Loan Coverage",
        ],
        icon: review,
    },
    {
        text: "Choose your solution and let us handle the application",
        subTitle: "No payment is due until you review and approve your policy",
        icon: submitApplication,
    },
    {
        text: "Once approved, sign and pay initial premium to activate your coverage",
        icon: shieldProtected3,
    },
];

export const ComplimentaryReviewBusinessSolutions = {
    title: "Schedule your complimentary review",
    text: "To customize your personal solution, we need to connect for a quick call. Together, we'll review your best options from a choice of the top rated insurance companies and most competitive rates.<br><br>It's easy, confidential and takes less than 15 minutes!",
    note: "Your information is private and secure, and is never sold to a third party.",
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/CustomAppointmentData.js